// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ly-3";
export var downloadButton = "_ly-4";
export var fileContainer = "_ly-9 _ly-7";
export var fileContainerBase = "_ly-7";
export var fileContainerFixedHeight = "_ly-8 _ly-7";
export var fileInfo = "_ly-5";
export var fileInfoWidthRestricted = "_ly-6";
export var fileType = "_ly-1";
export var fileTypeName = "_ly-2";
export var image = "_ly-0";
export var link = "_ly-b";
export var overflowEllipsis = "_ly-a";